import React from "react";
import { MessageCircle } from "lucide-react";

interface FloatingWhatsAppProps {
  phoneNumber?: string;
  defaultMessage?: string;
}

export const FloatingWhatsApp: React.FC<FloatingWhatsAppProps> = ({
  phoneNumber = "573507679981",
  defaultMessage = "Hola, deseo recibir asesoría sobre Mi Asistente Legal IA y sus soluciones jurídicas.",
}) => {
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
    defaultMessage
  )}`;

  return (
    <aside aria-label="Contacto por WhatsApp">
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 left-8 z-50 group flex items-center gap-2.5 bg-emerald-500 hover:bg-emerald-600 text-white px-4 py-3 rounded-full shadow-2xl shadow-emerald-600/30 transition-all duration-300 hover:scale-105 focus:outline-none focus:ring-4 focus:ring-emerald-400/40"
        aria-label="Contactar por WhatsApp al 350 767 9981"
      >
        <div className="relative">
          <MessageCircle className="w-6 h-6 fill-white stroke-emerald-500" />
          <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-white rounded-full animate-ping" />
          <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-emerald-200 rounded-full" />
        </div>
        <span className="text-xs sm:text-sm font-extrabold pr-1 tracking-wide hidden sm:inline-block">
          ¿Dudas? Chatea con un asesor
        </span>
      </a>
    </aside>
  );
};

export default FloatingWhatsApp;

